export const MGM_CTA_EXPERIMENT_ID = '351933';
export const MGM_CTA_EXPERIMENT_VARIANT = '53532';
export const MGM_CTA_PURPLE_EXPERIMENT_VARIANT = '53533';

export const CHANGES_PREVIEW_XP_ID = '351021';
export const CHANGES_PREVIEW_XP_VARIANT_ID = '52108';

export const WEB_TO_APP_XP_ID = '352602';
export const WEB_TO_APP_DOWLOAD_XP_VARIANT = '54456';
export const WEB_TO_APP_CHOICE_XP_VARIANT = '54457';
